// Externe Bibliotheken
import React, { Component } from 'react';
import axios from 'axios';

// Interne Module
import * as storage from '@/_helper/storage';
import tracking from '@/_helper/tracking';
import { convertPrice } from '@/_helper/mapper';
import { checkTripStarts } from '@/_helper/checkTripStarts.jsx';
import { checkIsAllowToBookService } from '@/_helper/checkAccess';
import getDurationDays, { getShortWeekday, mapRooms } from '@/_helper/bookingDetailsHelper';

// Komponenten
import Header from '@/comp/header/Header';
import Footer from '@/comp/footer/Footer';
import StatusPage from '@/comp/statusPage/statusPage';
import Button from '@/comp/button/button';

// Styles
import './cancellation.scss';

const params = {
    errorWording: {
        accept: 'Bitte bestätigen Sie, dass Sie die AGB und die Zahlungs- und Stornierungsbedingungen gelesen und zur Kenntnis genommen haben!',
    },
};

class Index extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pageLoad: false,
            data: {},
            bookingId: storage.get('bookingNumber') ? storage.get('bookingNumber') : '',
            formErrors: {
                accept: '',
            },
            acceptCheckbox: false,
            formValid: false,
            formVacancy: false,
            success: false,
            alreadyTested: false,
            trackData: true,
        };

        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        document.title = 'Stornierung' + window.$documentTitle;
        document.querySelector('html').classList.add('redesign');

        if (
            checkIsAllowToBookService('Cancellation') &&
            storage.get('bookingData') != null &&
            storage.get('bookingData').data != null &&
            !checkTripStarts()
        ) {
            let data = storage.get('bookingData').data;
            this.setState((state) => {
                state.data = data;
                state.success = data.bookingCancelled ? data.bookingCancelled : false;
                state.pageState = data.bookingCancelled ? 'success' : 'loading';
                state.pageLoad = data.bookingCancelled !== undefined ? data.bookingCancelled : '';
                return state;
            });

            if (!data.bookingCancelled) {
                checkIsAllowToBookService('Cancellation');
                tracking('loaded', 'cancellation');
                this.requestCancellation();
            }
        } else {
            setTimeout(() => {
                    window.location.href = '#/';
            }, 0);
        }
    }

    requestCancellation() {
        axios({
            url:
                window.$serviceUrl +
                '/cancellationcosts?requestType=cancellationcosts&clientId=customerarea&bookingid=' +
                this.state.bookingId +
                '&token=' +
                window.$token,
            method: 'GET',
        })
            .then((response) => response)
            .then((data) => {
                let cancelPaymentInformation = data.data?.data?.paymentCancellationPolicy;
                let cancellationParams = {};
                let cancelled;

                // set situational error messages -> StatusPage : error
                let cancellationErrorInfo = cancelPaymentInformation?.cancellationErrorInfo;
                let cancellationInfoText = cancelPaymentInformation?.cancellationInfoText;

                if (cancellationErrorInfo || cancellationInfoText) {
                    let errorCase = null;
                    switch (true) {
                        //  already cancelled
                        case cancellationErrorInfo?.includes('Booking is already cancelled'):
                            errorCase = 'alreadyCancelled';
                            break;
                        // package price not given || request by phone
                        case cancellationErrorInfo?.includes('package price not given'):
                        case cancellationInfoText?.includes('Stornokosten bitte bei AurumTours telefonisch anfragen'):
                            errorCase = 'contactCustomerService';
                            break;
                        //  travel start already done
                        case cancellationErrorInfo?.includes('Die Reise hat bereits begonnen oder ist abgeschlossen'):
                        case cancellationErrorInfo?.includes('Die Reise ist abgeschlossen'):
                            errorCase = 'travelStartAlreadyDone';
                            break;
                        default:
                    }

                    if (errorCase) {
                        this.setState({
                            pageState: 'error',
                            errorCase: errorCase,
                        });

                        return false;
                    }
                }

                if (cancelPaymentInformation !== undefined && cancelPaymentInformation.haveCancellationInfo) {
                    let cancellationPrice = cancelPaymentInformation.customer.currentCancellationPrice;
                    let crisisCancel = data.data.data.crisisCancel;
                    let goodWillCancel = data.data.data.goodWillCancel;

                    cancelled = data.data.data.bookingInformation.cancelled;

                    cancellationParams['cancellationPrice'] = cancellationPrice;
                    cancellationParams['crisisCancel'] = crisisCancel;
                    cancellationParams['goodWillCancel'] = goodWillCancel;
                    cancellationParams['cancelled'] = cancelled;

                    this.setState((state) => {
                        state.data.cancellationParams = cancellationParams;
                        state.pageLoad = true;
                        state.pageState = cancelled ? 'success' : 'loaded';
                        state.success = cancelled;
                        return state;
                    });
                } else {
                    this.setState({
                        error: true,
                        pageState: 'error',
                        pageLoad: true,
                        trackData: false,
                    });
                }
            })
            .catch(() => {
                this.setState({
                    pageLoad: false,
                    pageState: 'error',
                    trackData: true,
                });
            });
    }

    handleCheckboxChange(name) {
        if (Object.keys(this.state).includes(name)) {
            let checkboxValue = this.state[name];

            this.setState(
                {
                    [name]: !checkboxValue,
                },
                () => {
                    this.validateField(name, checkboxValue);
                }
            );
        }
    }

    validateField(fieldName) {
        let fieldValidationErrors = this.state.formErrors;
        let acceptValid = this.state.acceptValid;

        switch (fieldName) {
            case 'acceptCheckbox':
                acceptValid = this.state[fieldName];
                fieldValidationErrors.accept = acceptValid ? '' : params.errorWording.accept;
                break;
            default:
                break;
        }

        this.setState({ formErrors: fieldValidationErrors, acceptValid: acceptValid }, this.validateForm);
    }

    validateForm() {
        this.setState({ formValid: this.state.acceptValid });
    }

    handleSubmit(event) {
        event.preventDefault();

        this.setState({
            error: false,
            alreadyTested: true,
        });

        // form validation
        this.validateField('acceptCheckbox');

        if (!this.state.formValid) {
            // form is invalid! so we do nothing

            // set error dialogs
            let fieldValidationErrors = this.state.formErrors;
            fieldValidationErrors.accept = params.errorWording.accept;

            this.setState({
                formErrors: fieldValidationErrors,
            });

            return;
        }
        // form is valid!

        let sendParams;
        if (this.state.bookingId && this.state.data.searchParams && this.state.data.searchParams.travelType) {
            sendParams = {
                clientId: 'customerarea',
                bookingId: this.state.bookingId,
                travelType: this.state.data.searchParams.travelType,
                requestType: 'cancelBooking',
                requestSource: 'customerarea',
            };
        }

        this.setState({
            formVacancy: true,
        });

        if (sendParams === undefined) {
            return;
        }

        axios({
            url: window.$serviceUrl + '/cancelBooking?token=' + window.$token,
            method: 'POST',
            data: sendParams,
        })
            .then((response) => response)
            .then((response) => {
                let success = response.data?.data?.cancellationResult === 'cancelled';

                if (success) {
                    let bookingData = storage.get('bookingData');

                    if (bookingData && bookingData.data) {
                        bookingData.data.bookingCancelled = true;
                        storage.set('bookingData', bookingData);
                    }

                    // set
                    this.setState({
                        pageState: 'success',
                        formVacancy: false,
                        success: true,
                        trackData: true,
                    });
                } else {
                    this.setState({
                        pageState: 'error',
                        formVacancy: false,
                        trackData: true,
                    });
                }
            })
            .catch(() => {
                this.setState({
                    pageState: 'error',
                    formVacancy: false,
                    trackData: true,
                });
            });
    }

    render() {
        const { data } = this.state;

        const hotelDetails = data.frontendParams?.hotelDetails[0];
        const flightDetails = data.frontendParams?.flightDetails;

        const travelDuration = getDurationDays(hotelDetails?.checkIn, hotelDetails?.checkOut);
        const amountChildren = data?.searchParams?.children + data?.searchParams?.babies;

        const getActiveCount = (arr) => arr.filter((item) => item.state === 'OK').length ?? 0;

        const hasActiveExcursion =
            data?.frontendParams?.excursions !== undefined && getActiveCount(data?.frontendParams?.excursions) > 0;

        const hasActiveSeatReservation =
            data?.serviceInformation?.bookedSeats !== undefined &&
            getActiveCount(data?.serviceInformation?.bookedSeats) > 0;

        const stars = (category) => {
            const arr = [];
            for (let i = 0; i < parseInt(category ?? null); i++) {
                arr.push(
                    <i key={`star-${i}`} className="material-symbols-outlined">
                        star
                    </i>
                );
            }
            return arr;
        };

        const mainPackagePrice = (packages) => {
            for (const [key, value] of Object.entries(packages)) {
                if (key.startsWith('AUR') || key.startsWith('AT')) {
                    return convertPrice(Number(value));
                }
            }
        };

        const accServicePrices = (service) =>
            convertPrice(service?.map((item) => item.price)?.reduce((acc, curr) => acc + curr));

        const flightElement = (flight) => (
            <div key={`flight-${flight.flightNumber}`}>
                {`${getShortWeekday(flight.depDate)}., ${flight.depDate}`}
                &nbsp;&middot;&nbsp;
                {`${flight.depAirportDescription} (${flight.depAirportCode}) - ${flight.arrAirportDescription} (${flight.arrAirportCode})`}
            </div>
        );

        return (
            <div className="page-cancellation">
                <Header />

                {this.state.pageState === 'success' ? (
                    <StatusPage type="success" subPage="cancellation" />
                ) : this.state.pageState === 'error' ? (
                    <StatusPage
                        type="error"
                        case={this.state.errorCase ? this.state.errorCase : false}
                        subPage="cancellation"
                        trackData={this.state.trackData}
                    />
                ) : (
                    <div className="content-wrapper">
                        <h1 className="main-headline">Gesamte Reise stornieren</h1>
                        <div className="subline">Hier können Sie schnell und einfach Ihre Reise stornieren.</div>

                        {this.state.pageLoad ? (
                            <form
                                className={this.state.formVacancy ? 'validate' : ''}
                                onSubmit={this.handleSubmit}
                                onChange={() => tracking('interaction', 'cancellation')}>
                                <h2>Meine Reise nach {data.searchParams.destinationDescription}</h2>
                                <div className="content">
                                    <section className="travel-overview">
                                        <div className="element hotel-name">
                                            <i className="material-symbols-outlined">location_away</i>
                                            <div>
                                                {hotelDetails?.name}
                                                <span className="stars">{stars(hotelDetails?.category)}</span>
                                            </div>
                                        </div>
                                        <div className="element">
                                            <i className="material-symbols-outlined">location_on</i>
                                            <div>
                                                {hotelDetails?.address1}
                                                {hotelDetails?.address2?.length > 0 && ', ' + hotelDetails?.address2}
                                                {hotelDetails?.address3?.length > 0 && ', ' + hotelDetails?.address3}
                                                {hotelDetails?.address4?.length > 0 && ', ' + hotelDetails?.address4}
                                            </div>
                                        </div>
                                        <div className="element">
                                            <i className="material-symbols-outlined">bed</i>
                                            <div>
                                                <div>
                                                    {`${travelDuration} ${travelDuration === 1 ? 'Nacht' : 'Nächte'}`}{' '}
                                                    vom {hotelDetails?.checkIn} bis {hotelDetails?.checkOut}
                                                </div>
                                                {mapRooms(hotelDetails?.rooms)?.map((item, index) => {
                                                    return (
                                                        <div key={index}>
                                                            {item?.count > 1 || hotelDetails?.rooms?.length > 1
                                                                ? `${item.count} `
                                                                : ''}
                                                            {item?.name}&nbsp;&middot;&nbsp;{item?.meal}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                        <div className="element">
                                            <i className="material-symbols-outlined">how_to_reg</i>
                                            <div>
                                                <>{`${data?.searchParams?.adults} ${
                                                    data?.searchParams?.adults?.length === 1
                                                        ? 'Erwachsener'
                                                        : 'Erwachsene'
                                                }`}</>
                                                {amountChildren !== undefined && amountChildren > 0 && (
                                                    <>
                                                        &nbsp;&middot;&nbsp;
                                                        {`${amountChildren} ${
                                                            amountChildren === 1 ? 'Kind' : 'Kinder'
                                                        }`}
                                                    </>
                                                )}
                                                <></>
                                            </div>
                                        </div>
                                        {flightDetails && (
                                            <>
                                                <div className="element flight-outbound">
                                                    <i className="material-symbols-outlined">flight</i>
                                                    <div>
                                                        {flightDetails?.outbound?.map((flight) =>
                                                            flightElement(flight)
                                                        )}
                                                    </div>
                                                </div>
                                                <div className="element flight-inbound">
                                                    <i className="material-symbols-outlined">flight</i>
                                                    <div>
                                                        {flightDetails?.inbound?.map((flight) => flightElement(flight))}
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                        {hasActiveExcursion && (
                                            <div className="element">
                                                <i className="material-symbols-outlined">attractions</i>
                                                <div>
                                                    Mit{' '}
                                                    {getActiveCount(data?.frontendParams?.excursions) === 1
                                                        ? 'Ausflug'
                                                        : `${getActiveCount(
                                                              data?.frontendParams?.excursions
                                                          )} Ausflügen`}
                                                </div>
                                            </div>
                                        )}
                                        {hasActiveSeatReservation && (
                                            <div className="element">
                                                <i className="material-symbols-outlined">airline_seat_recline_normal</i>
                                                <div>Mit Sitzplatzreservierung (Flug)</div>
                                            </div>
                                        )}
                                        {data?.serviceInformation?.transfer && (
                                            <div className="element">
                                                <i className="material-symbols-outlined">airport_shuttle</i>
                                                <div>Mit Transfer</div>
                                            </div>
                                        )}
                                        {data?.serviceInformation?.railAndFly?.length > 0 && (
                                            <div className="element">
                                                <i className="material-symbols-outlined">train</i>
                                                <div>Mit Rail & Fly</div>
                                            </div>
                                        )}
                                    </section>

                                    <section className="cancellation-overview">
                                        <div>
                                            <h3>Gesamtkosten</h3>
                                            <div className="element">
                                                <i className="material-symbols-outlined">beach_access</i>
                                                <div className="package-type">
                                                    Reise{' '}
                                                    {data?.serviceInformation?.transfer &&
                                                    data?.serviceInformation?.railAndFly?.length > 0 ? (
                                                        <>inkl. Transfer und Rail & Fly</>
                                                    ) : data?.serviceInformation?.transfer ? (
                                                        <>inkl. Transfer</>
                                                    ) : data?.serviceInformation?.railAndFly?.length > 0 ? (
                                                        <>inkl. Rail & Fly</>
                                                    ) : (
                                                        <></>
                                                    )}
                                                </div>
                                                <div>
                                                    {mainPackagePrice(data.frontendParams?.price?.packageDetails)}
                                                </div>
                                            </div>
                                            {hasActiveExcursion && (
                                                <div className="element">
                                                    <i className="material-symbols-outlined">attractions</i>
                                                    <div className="package-type">
                                                        {getActiveCount(data?.frontendParams?.excursions) === 1
                                                            ? 'Ausflug'
                                                            : 'Ausflüge'}
                                                    </div>
                                                    <div>{accServicePrices(data?.frontendParams?.excursions)}</div>
                                                </div>
                                            )}
                                            {hasActiveSeatReservation && (
                                                <div className="element">
                                                    <i className="material-symbols-outlined">
                                                        <span className="material-symbols-outlined">
                                                            airline_seat_recline_normal
                                                        </span>
                                                    </i>
                                                    <div className="package-type">
                                                        {getActiveCount(data?.serviceInformation?.bookedSeats) === 1
                                                            ? 'Sitzplatzreservierung'
                                                            : 'Sitzplatzreservierungen'}
                                                    </div>
                                                    <div>{accServicePrices(data?.serviceInformation?.bookedSeats)}</div>
                                                </div>
                                            )}
                                        </div>
                                        <div>
                                            <hr />
                                            <div className="refund-info">
                                                Bereits geleistete Zahlungen (Restzahlung/Anzahlung) an AurumTours
                                                werden mit der ursprünglich bei Buchung angegebenen Zahlungsmethode
                                                erstattet.
                                            </div>
                                            {hasActiveSeatReservation && (
                                                <div className="info seat-reservation">
                                                    <i className="material-symbols-outlined">info</i>
                                                    Kosten für reservierte Sitzplätze können nicht erstattet werden.
                                                </div>
                                            )}
                                            <div
                                                className={`cancellation-cost${
                                                    data.cancellationParams.cancellationPrice === 0
                                                        ? ' free-cancellation'
                                                        : ''
                                                }`}>
                                                <div className="price">
                                                    <div>Stornierungskosten</div>
                                                    <div>
                                                        {`${convertPrice(
                                                            data.cancellationParams.cancellationPrice,
                                                            0,
                                                            0
                                                        )}`}
                                                    </div>
                                                </div>
                                                {(data.cancellationParams.crisisCancel === true ||
                                                    data.cancellationParams.cancellationPrice !== 0) && (
                                                    <div className="info">
                                                        <i className="material-symbols-outlined">info</i>
                                                        {data.cancellationParams.crisisCancel === true ? (
                                                            <>
                                                                Aufgrund der aktuellen Situation ermöglicht AurumTours
                                                                eine kostenlose Stornierung der Reise.
                                                            </>
                                                        ) : data.cancellationParams.cancellationPrice !== 0 ? (
                                                            <>
                                                                Die Stornierungsgebühren entsprechen der
                                                                Stornierungskategorie Ihrer Reisebuchung.
                                                            </>
                                                        ) : (
                                                            <></>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </section>

                                    <section className="accept-sec">
                                        <div className="checkbox-input">
                                            <input
                                                id="acceptCheckbox"
                                                name="acceptCheckbox"
                                                type="checkbox"
                                                checked={this.state.acceptCheckbox}
                                                onChange={() => this.handleCheckboxChange('acceptCheckbox')}
                                            />
                                            <span
                                                className="icon"
                                                onClick={() => this.handleCheckboxChange('acceptCheckbox')}></span>
                                            <label htmlFor="acceptCheckbox">
                                                Ja, ich möchte meine Reise jetzt stornieren. Ich akzeptiere die{' '}
                                                <a
                                                    href={`${window.$website}/unternehmen/agb`}
                                                    target="_blank"
                                                    rel="noopener noreferrer">
                                                    Allgemeinen Geschäftsbedingungen
                                                </a>{' '}
                                                sowie die{' '}
                                                <a
                                                    href={`${window.$website}/unternehmen/agb`}
                                                    target="_blank"
                                                    rel="noopener noreferrer">
                                                    Zahlungs- und Stornierungsbedingungen
                                                </a>{' '}
                                                der AurumTours GmbH.
                                            </label>
                                        </div>

                                        {this.state.acceptValid === false &&
                                            this.state.alreadyTested &&
                                            this.state.formErrors.accept.length > 0 && (
                                                <div className="error">{this.state.formErrors.accept}</div>
                                            )}

                                        <Button
                                            valid={this.state.formValid}
                                            validated={this.state.formVacancy}
                                            type="submit"
                                            label={
                                                this.state.formVacancy
                                                    ? 'Daten werden übermittelt'
                                                    : data.cancellationParams.cancellationPrice === 0
                                                      ? 'Jetzt kostenlos stornieren'
                                                      : `Jetzt für ${convertPrice(
                                                            data.cancellationParams.cancellationPrice,
                                                            0,
                                                            0
                                                        )} stornieren`
                                            }
                                            icon="arrow_forward"
                                        />

                                        <small className="txtR">
                                            Sie erhalten im Anschluss eine Stornierungsbestätigung per E-Mail.
                                        </small>

                                        {this.state.error === true && (
                                            <div className="error txtR">{window.$content.errorText}</div>
                                        )}
                                    </section>
                                </div>
                            </form>
                        ) : (
                            <div className="loading lazy-load-background">
                                <span className="headline" />
                                <div className="content">
                                    <div>
                                        <span className="element" />
                                        <span className="element" />
                                        <span className="element" />
                                    </div>
                                    <div>
                                        <span className="element" />
                                        <span className="element" />
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
                <Footer />
            </div>
        );
    }
}

export default Index;
